/* eslint-disable */

// Polyfill for structuredClone, taken from
// https://github.com/ungap/structured-clone
// Copied from bark-lib/static/js/clone.ts

// @ts-expect-error untyped polyfill
// prettier-ignore
const StructuredClone = function (e) {
  "use strict";

  const t = "object" == typeof self ? self : globalThis,
    r = e => ((e, r) => {
      const n = (t, r) => (e.set(r, t), t),
        s = c => {
          if (e.has(c)) return e.get(c);
          const [o, u] = r[c];
          switch (o) {
            case 0:
            case -1:
              return n(u, c);
            case 1:
              {
                const e = n([], c);
                for (const t of u) e.push(s(t));
                return e;
              }
            case 2:
              {
                const e = n({}, c);
                for (const [t, r] of u) e[s(t)] = s(r);
                return e;
              }
            case 3:
              return n(new Date(u), c);
            case 4:
              {
                const {
                  source: e,
                  flags: t
                } = u;
                return n(new RegExp(e, t), c);
              }
            case 5:
              {
                const e = n(new Map(), c);
                for (const [t, r] of u) e.set(s(t), s(r));
                return e;
              }
            case 6:
              {
                const e = n(new Set(), c);
                for (const t of u) e.add(s(t));
                return e;
              }
            case 7:
              {
                const {
                  name: e,
                  message: r
                } = u;
                return n(new t[e](r), c);
              }
            case 8:
              return n(BigInt(u), c);
            case "BigInt":
              return n(Object(BigInt(u)), c);
          }
          return n(new t[o](u), c);
        };
      return s;
    })(new Map(), e)(0),
    n = "",
    {
      toString: s
    } = {},
    {
      keys: c
    } = Object,
    o = e => {
      const t = typeof e;
      if ("object" !== t || !e) return [0, t];
      const r = s.call(e).slice(8, -1);
      switch (r) {
        case "Array":
          return [1, n];
        case "Object":
          return [2, n];
        case "Date":
          return [3, n];
        case "RegExp":
          return [4, n];
        case "Map":
          return [5, n];
        case "Set":
          return [6, n];
      }
      return r.includes("Array") ? [1, r] : r.includes("Error") ? [7, r] : [2, r];
    },
    u = ([e, t]) => 0 === e && ("function" === t || "symbol" === t),
    a = (e, {
      json: t,
      lossy: r
    } = {}) => {
      const n = [];
      return ((e, t, r, n) => {
        const s = (e, t) => {
            const s = n.push(e) - 1;
            return r.set(t, s), s;
          },
          a = n => {
            if (r.has(n)) return r.get(n);
            let [i, f] = o(n);
            switch (i) {
              case 0:
                {
                  let t = n;
                  switch (f) {
                    case "bigint":
                      i = 8, t = n.toString();
                      break;
                    case "function":
                    case "symbol":
                      if (e) throw new TypeError("unable to serialize " + f);
                      t = null;
                      break;
                    case "undefined":
                      return s([-1], n);
                  }
                  return s([i, t], n);
                }
              case 1:
                {
                  if (f) return s([f, [...n]], n);
                  const e = [],
                    t = s([i, e], n);
                  for (const t of n) e.push(a(t));
                  return t;
                }
              case 2:
                {
                  if (f) switch (f) {
                    case "BigInt":
                      return s([f, n.toString()], n);
                    case "Boolean":
                    case "Number":
                    case "String":
                      return s([f, n.valueOf()], n);
                  }
                  if (t && "toJSON" in n) return a(n.toJSON());
                  const r = [],
                    l = s([i, r], n);
                  for (const t of c(n)) !e && u(o(n[t])) || r.push([a(t), a(n[t])]);
                  return l;
                }
              case 3:
                return s([i, n.toISOString()], n);
              case 4:
                {
                  const {
                    source: e,
                    flags: t
                  } = n;
                  return s([i, {
                    source: e,
                    flags: t
                  }], n);
                }
              case 5:
                {
                  const t = [],
                    r = s([i, t], n);
                  for (const [r, s] of n) (e || !u(o(r)) && !u(o(s))) && t.push([a(r), a(s)]);
                  return r;
                }
              case 6:
                {
                  const t = [],
                    r = s([i, t], n);
                  for (const r of n) !e && u(o(r)) || t.push(a(r));
                  return r;
                }
            }
            const {
              message: l
            } = n;
            return s([i, {
              name: f,
              message: l
            }], n);
          };
        return a;
      })(!(t || r), !!t, new Map(), n)(e), n;
    };
  var i = "function" == typeof structuredClone ? (e, t) => t && ("json" in t || "lossy" in t) ? r(a(e, t)) : structuredClone(e) : (e, t) => r(a(e, t));
  return e.default = i, e.deserialize = r, e.serialize = a, e;
}({});
export const clone = typeof structuredClone === 'function' ? structuredClone : StructuredClone.default;